module.exports = __webpack_public_path__ + "static/media/arrow.e17390ee.svg";